<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Please let us know your social handles.
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <!-- <div>
          <v-select
            dense
            placeholder="Platform"
            v-model="updateData.platform"
            :items="platforms"
            @input="$v.updateData.platform.$touch()"
            :error-messages="$v.updateData.platform.$error && `Platform is required.`"
            @blur="$v.updateData.platform.$touch()"
            outlined
            attach
          ></v-select>
        </div> -->
        <div>
          <label>Instagram</label>
          <v-text-field
            dense
            v-model="updateData.instagramHandle"
            type="text"
            placeholder=""
            outlined
          ></v-text-field>
        </div>
        <div>
          <label>TikTok</label>
          <v-text-field
            dense
            v-model="updateData.tiktokHandle"
            type="text"
            placeholder=""
            outlined
          ></v-text-field>
        </div>
        <div>
          <label class="d-flex align-center">
            <v-icon color="#1877F2" small class="mr-1">mdi-facebook</v-icon>
            Facebook
          </label>
          <v-text-field
            dense
            v-model="updateData.facebookHandle"
            type="text"
            placeholder="@handle or facebook.com/handle"
            outlined
          ></v-text-field>
        </div>
        <div>
          <label>Youtube</label>
          <v-text-field
            dense
            v-model="updateData.youtubeHandle"
            type="text"
            placeholder=""
            outlined
          ></v-text-field>
        </div>
        <div>
          <label class="d-flex align-center">
            <v-icon color="#0A66C2" small class="mr-1">mdi-linkedin</v-icon>
            LinkedIn
          </label>
          <v-text-field
            dense
            v-model="updateData.linkedinHandle"
            type="text"
            placeholder="@handle or linkedin.com/in/handle"
            outlined
          ></v-text-field>
        </div>
        <div>
          <label class="d-flex align-center">
            <img src="/static/img/x-logo.svg" width="14" height="14" class="mr-1" alt="" aria-hidden="true">
            X (Twitter)
          </label>
          <v-text-field
            dense
            v-model="updateData.twitterHandle"
            type="text"
            placeholder="@handle or x.com/handle"
            outlined
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="!updateData.instagramHandle && !updateData.tiktokHandle && !updateData.youtubeHandle && !updateData.facebookHandle && !updateData.linkedinHandle && !updateData.twitterHandle">Submit</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import influencerAPIs from './influencerAPIs';
import config from '@/config';
import utils from '@/utils';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'EditReportHandleModal',
  components: {
    Loading
  },
  props: {
    value: Boolean
  },
  validations: {
    updateData: {
      handle: { required },
      platform: { required }
    }
  },
  data () {
    return {
      isLoading: false,
      platforms: ['Instagram', 'TikTok', 'Youtube', 'Facebook', 'LinkedIn', 'X (Twitter)'],
      updateData: {
        instagramHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        facebookHandle: '',
        linkedinHandle: '',
        twitterHandle: '',
        platform: ''
      }
    }
  },
  async mounted() {
  },
  computed: {
    currentInfID: function() {
      return this.$store.state.user.influencerID;
    }
  },
  watch: {
    value: function(newValue) {
      this.updateData = {
        instagramHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        facebookHandle: '',
        linkedinHandle: '',
        twitterHandle: '',
        platform: ''
      }
    }
  },
  methods: {
    async save() {
      this.isLoading = true
      // if (this.updateData.platform === 'Instagram') {
      //   this.$emit('connectIG')
      //   this.close()
      //   return;
      // }
      this.updateData.instagramHandle = utils.func.espaceHandleSign(utils.func.regexMatchIg(this.updateData.instagramHandle, config.regexPattern.instagram_profile))
      this.updateData.tiktokHandle = utils.func.espaceHandleSign(utils.func.extractTikTokHandle(this.updateData.tiktokHandle))
      this.updateData.youtubeHandle = this.updateData.youtubeHandle ? this.updateData.youtubeHandle.trim() : ''
      this.updateData.facebookHandle = this.normalizeFacebookHandle(this.updateData.facebookHandle)
      this.updateData.linkedinHandle = this.normalizeLinkedInHandle(this.updateData.linkedinHandle)
      this.updateData.twitterHandle = this.normalizeTwitterHandle(this.updateData.twitterHandle)
      this.updateData.platform = [
        this.updateData.instagramHandle && 'Instagram',
        this.updateData.tiktokHandle && 'TikTok',
        this.updateData.youtubeHandle && 'YouTube',
        this.updateData.facebookHandle && 'Facebook',
        this.updateData.linkedinHandle && 'LinkedIn',
        this.updateData.twitterHandle && 'X (Twitter)'
      ].filter(Boolean).join(', ')
      let saveData = Object.assign({}, {
        influencerID: this.currentInfID,
        ...this.updateData
      })
      try {
        await influencerAPIs.updateInfPlatform(saveData)
        this.$swal({
          text: 'Successfully Requested.',
          type: 'success'
        }).then(() => {
          this.close()
          window.location.reload()
        });
      } catch (error) {
        const responseData = error && error.response ? error.response.data : null
        this.$swal({
          text: (responseData && responseData.message) || `Error updating ${this.updateData.platform}. Please try again.`,
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    close() {
      this.$emit('input')
    },
    normalizeTwitterHandle(value) {
      let handle = (value || '').trim()
      const twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i)
      if (twitterUrl) handle = twitterUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    normalizeFacebookHandle(value) {
      let handle = (value || '').trim()
      const profileURL = handle.match(/^(?:https?:\/\/)?(?:www\.)?facebook\.com\/profile\.php\?id=([^&#]+)/i)
      const pageURL = handle.match(/^(?:https?:\/\/)?(?:www\.)?facebook\.com\/([^/?#]+)/i)
      if (profileURL) handle = profileURL[1]
      else if (pageURL) handle = pageURL[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    normalizeLinkedInHandle(value) {
      let handle = (value || '').trim()
      const linkedInUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i)
      if (linkedInUrl) handle = linkedInUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    }
  }
};
</script>



// WEBPACK FOOTER //
// UpdatePlatformModal.vue?21964914